/**
 * ai.introspect - returns agent introspection plus local agent/context.json and models.json
 * args: { rootState }
 */
module.exports = async function introspect(_helpers = {}, args = {}) {
  void _helpers
  const { rootState } = args

  // Start with any existing introspection in state
  const agentIntrospect = (rootState && rootState.agent && rootState.agent.introspection) ? rootState.agent.introspection : {}

  // Load context and models (bundled JSON in repo)
  let contextJson = {}
  let modelsJson = {}
  try { contextJson = require('../agent/context.json') } catch (e) { contextJson = {} }
  try { modelsJson = require('../agent/models.json') } catch (e) { modelsJson = {} }

  return {
    timestamp: Date.now(),
    agentIntrospect,
    contextJson,
    modelsJson,
    keys: {
      context: Object.keys(contextJson || {}),
      models: Object.keys(modelsJson || {})
    }
  }
}
